import { render } from "./Html.vue?vue&type=template&id=5d534d51"
import script from "./Html.vue?vue&type=script&lang=js"
export * from "./Html.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__